<script setup lang="ts">
import { computed } from 'vue'
import type { TUiTypeValues, UiColor } from '../../../types/api/reports'
import { severityToColor } from './gwTableUtils'

const props = defineProps<{
  value: TUiTypeValues['percentage_decimal_one']
  severities?: UiColor[]
  hasUnit?: boolean
  isTableValue?: boolean
}>()

const color = computed(() => severityToColor(props.severities)(props.value))
</script>
<template>
  <div :style="isTableValue ? { color } : ''">
    {{ (value * 100).toFixed(1) }}{{ hasUnit ? '%' : '' }}
  </div>
</template>
